import {DataObjectId} from './data-object'
import {ObjUtil} from 'yougile-util'

export interface PartnerManager {
  name: string
  color: string
}

export interface PartnerDataCompany {
  timestamp: number
  displayAs: string
  converted: boolean
  payAmount: number
}

export interface PartnerDataUser {
  registeredAt: number
  displayAs: string
  companies: {[id: string]: PartnerDataCompany}
}

export interface PartnerDataManualRequest {
  timestamp: number
  registeredTime: number
  registeredId: DataObjectId
  name: string
  company: string
  phone: string
}

export interface PartnerData {
  phone: string
  timestamp: number
  refLink: string
  siteVisitors: number
  withdrawn: number
  requestedEmails: {[email: string]: PartnerDataManualRequest}
  referred: {[id: string]: PartnerDataUser}
  managerId?: string
}

export interface ReferralStat {
  active1d: number
  active1w: number
  allUsers: number
  msg1d: number
  msg1w: number
  tasks1d: number
  tasks1w: number
  source: string
}

const alphanum = 'abcdefghijklmnopqrstuvwxyz0123456789'
export const createRefLink = (): string => {
  const res: string[] = []
  for (let i = 0; i < 5; i++) {
    res.push(alphanum[Math.round(Math.random() * (alphanum.length - 1))])
  }
  return res.join('')
}

export const getTotalPartnerEarnings = (data: PartnerData) => {
  if (!data) {
    return 0
  }
  let sum = 0
  for (const ref of ObjUtil.values(data.referred)) {
    for (const c of ObjUtil.values(ref.companies)) {
      sum += c.payAmount
    }
  }
  return sum * 0.2
}
